import { useTypedQuery } from "hooks";
import { DMSCapabilitiesQueryKeys } from "modules/DMSv3/Capabilities/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDMSCapabilitiesQuery = () =>
  useTypedQuery({
    queryKey: DMSCapabilitiesQueryKeys.capabilities,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, {}, baseUrl)).data.dms
  });
